import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as BookIcon } from 'assets/icons/Book.svg';
import { Popover, Typography } from 'antd';

export const GlossairePopover = () => {
  const { t } = useTranslation('glossaire');
  return (
    <Popover
      rootClassName="no-padding-popover white-popover"
      content={
        <div className="flex justify-between items-center px-6 py-3">
          <Typography.Paragraph className="!mb-0 font-bold">
            {t('title')}
          </Typography.Paragraph>
        </div>
      }
      placement="bottom"
    >
      <BookIcon />
    </Popover>
  );
};
